import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppointmentMapService {

  private resetMapData:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false); 
  private lastMapLocation:BehaviorSubject<any> = new BehaviorSubject<any>('');
  private scriptStore:any = [
    {name: 'mapload', src: environment.mmi.mapload_url},
    {name: 'mapsdk', src: environment.mmi.mapsdk_url}
  ];
  private scripts: any = {};

  constructor() {
    this.scriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
            loaded: false,
            src: script.src
        };
    });
   }

  public getResetMapData(){
    return this.resetMapData.asObservable();
  }

  public setResetMapData(){
    this.resetMapData.next(!this.resetMapData.value);
  }

  public setLastMapLocation(location:any){
    this.lastMapLocation.next(location);
  }

  public get getLastMapLocation(){
    return this.lastMapLocation.asObservable();
  }

  //load dynamic scripts
  load(...scripts: string[]) {
    var promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
      return new Promise((resolve, reject) => {
          //resolve if already loaded
          if (this.scripts[name].loaded) {
              resolve({script: name, loaded: true, status: 'Already Loaded'});
          }
          else {
              //load script
              let script:any = document.createElement('script');
              script.type = 'text/javascript';
              script.src = this.scripts[name].src;
              script.async = true;
              script.defer = true;
              if (script.readyState) {  //IE
                  script.onreadystatechange = () => {
                      if (script.readyState === "loaded" || script.readyState === "complete") {
                          script.onreadystatechange = null;
                          this.scripts[name].loaded = true;
                          resolve({script: name, loaded: true, status: 'Loaded'});
                      }
                  };
              } else {  //Others
                  script.onload = () => {
                      this.scripts[name].loaded = true;
                      resolve({script: name, loaded: true, status: 'Loaded'});
                  };
              }
              script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
              document.getElementsByTagName('head')[0].appendChild(script);
          }
      });

  }

}
